export default {
    CHARGEBEE_INITIALIZED(state) {
        state.chargebeeInitialized = true;
    },
};
